import { render, staticRenderFns } from "./Lgx296721465535889408.vue?vue&type=template&id=22cf725c&scoped=true&"
import script from "./Lgx296721465535889408.vue?vue&type=script&lang=js&"
export * from "./Lgx296721465535889408.vue?vue&type=script&lang=js&"
import style0 from "./Lgx296721465535889408.vue?vue&type=style&index=0&id=22cf725c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cf725c",
  null
  
)

export default component.exports